import { getLocal } from './storage';

export type ThemePreference = 'light' | 'dark' | 'system';

/** Misma lógica que `useDarkMode`: resultado efectivo (claro u oscuro). */
export function resolveEffectiveTheme(pref: ThemePreference): boolean {
  if (pref === 'dark') return true;
  if (pref === 'light') return false;
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/**
 * Aplica la clase `dark` en `<html>` antes del primer render de React,
 * usando la misma preferencia que `useDarkMode` (localStorage `theme`).
 */
export function initThemeClass(): void {
  if (typeof document === 'undefined') return;
  const pref = getLocal<ThemePreference>('theme', 'system');
  document.documentElement.classList.toggle('dark', resolveEffectiveTheme(pref));
}
